import React from 'react';
import { inject, observer } from 'mobx-react';
import styles from './index.module.scss';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import { BASE_IMG_URL, getUserLevelBadge } from '@images/imageUrls';
import { getAvatarImageSrc } from '@utils/avatarImageSrc';
interface PCAvatarProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    data?: any
    size?: number  // 头像尺寸
    avatarUrl?: any    // 头像图片
    userCode?: any    // 用户Id
    userClick?: Function    // 头像点击事件
    showOfficialTag?: boolean  // 是否显示官方标识，默认显示
    titleMark?: any // 官方
    level?: number | string  // 用户等级 1-7
    officialSize?: any  // 官方标识尺寸大小，默认16px
    levelBadgeWidth?: number
    levelBadgeHeight?: number
}

@inject('app', 'site', 'user')
@observer
class PCAvatar extends React.Component<PCAvatarProps> {
    // 处理图片加载错误
    handleImageError: React.ReactEventHandler<HTMLImageElement> = (event) => {
        const imgElement = event.currentTarget;
        const avatarSize = this.props.size || 60;
        imgElement.src = getAvatarImageSrc(`${BASE_IMG_URL}/common/avatar.png`, avatarSize, avatarSize);
        // 防止默认图也加载失败时陷入死循环
        imgElement.onerror = null;
    };
    componentDidMount() {
        // 可以在这里添加初始化逻辑
    }

    render() {
        const { data, avatarUrl, size, userCode, userClick, titleMark, level, officialSize = 16, showOfficialTag = true, levelBadgeWidth, levelBadgeHeight } = this.props;
        const avatarSize = size || 60;
        const avatarSrc = getAvatarImageSrc(avatarUrl || data?.avatar || `${BASE_IMG_URL}/common/avatar.png`, avatarSize, avatarSize);
        const levelBadge = getUserLevelBadge(level ?? data?.level);
        const normalizedTitleMark = Number(titleMark);
        const hasOfficialTag = normalizedTitleMark === 1 || normalizedTitleMark === 2;
        const badgeWidth = levelBadgeWidth || Math.round(avatarSize * 0.36);
        const badgeHeight = levelBadgeHeight || Math.round(badgeWidth / 1.5);
        const levelStyle = {
            width: `${badgeWidth}px`,
            height: `${badgeHeight}px`,
            right: '0px',
            bottom: '0px',
        };
        // 正确的 style 对象
        const sizeStyle = size ? {
            width: `${size}px`,
            height: `${size}px`
        } : {};
        return <>
            <div className={styles.userAvatarBox} style={sizeStyle} onClick={(e)=> {
                // console.log('点击');
                // this.props.history && this.props.history.push(`/topic/${id}`);
                userClick && userClick();
            }}>
                <img src={avatarSrc} onError={this.handleImageError}  alt="" className={styles.avatar}/>
                {showOfficialTag && <>
                    {/* 黑色官方标识 */}
                    {(titleMark == 2 && size > 28) && <img src={`${BASE_IMG_URL}/common/official1.png`} alt="" style={{width: officialSize + 'px'}} className={styles.official}/>}
                    {(titleMark == 2 && size <= 28) && <div className={styles.officialCircle2}></div>}
                    {/* 蓝色官方标识 */}
                    {(titleMark == 1 && size > 28) && (
                        <img src={`${BASE_IMG_URL}/common/official2.png`} alt="" style={{width: officialSize + 'px'}} className={styles.official}/>
                    )}
                    {(titleMark == 1 && size <= 28) && <div className={styles.officialCircle1}></div>}
                    {!hasOfficialTag && levelBadge && (
                        <img src={levelBadge} alt={`V${level ?? data?.level}`} style={levelStyle} className={styles.level}/>
                    )}
                </>}
                
            </div>
        </>;
        
    }
}

export default PCAvatar;
